import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'
import { useUser } from '~/@biz_account/useUser/useUser'
import { SecuritySettingsForm } from './SecuritySettingsForm'

function SecuritySettings() {
  const { user, reloadUser } = useUser()
  const twoFaInitial = user?.meta.login2FAEnabled ?? false

  const { setNotification } = useLocalNotifications()

  function handleSuccess() {
    setNotification(
      'info',
      'Nastavenie dvojfaktorovej autentifikácie bolo uložené.'
    )
    reloadUser()
  }

  if (!user) return null

  return (
    <SecuritySettingsForm
      initialValues={{ isTwoFaEnabled: twoFaInitial }}
      onSuccess={handleSuccess}
    />
  )
}

export { SecuritySettings }
